import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=46db362c&scoped=true"
import script from "./IconButton.vue?vue&type=script&lang=ts"
export * from "./IconButton.vue?vue&type=script&lang=ts"
import style0 from "./IconButton.vue?vue&type=style&index=0&id=46db362c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46db362c",
  null
  
)

export default component.exports